<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='baseMessages' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white fh">
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <span v-if="item.key === 'isRead'" :class="scope.row[item.key] | isFinishFilter">
                  <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                               v-if="item.isSel"></select-type>
              </span>
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-else-if="item.isSel">
              </select-type>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{ scope.row[item.key] | dateFormat }}</span>
                <span v-else-if="item.key==='title'">
                  <a class="link-type" @click.stop="openDrawer(scope.row,'baseMessages')">{{ scope.row[item.key] }}</a>
                </span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <add-instance ref="dataForm" :sourceCode="crmType"
                    :visible.sync="dialogFormVisible"
                    :initData="initData">
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     :visible.sync="dialogEditVisible"
                     :initData="temp">
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
    </div>
  </div>
</template>

<script>
import * as baseMessages from '@/api/basemessages';
import mytable from '@/utils/crmtableFlowV2';

export default {
  name: 'baseMessages',
  components: {},
  mixins: [mytable],
  data() {
    return {
      crmType: 'BaseMessage',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      rules: {}
    };
  },
  filters: {
    isFinishFilter(status) {
      var res = 'color-success';
      switch (status) {
        case 0:
          res = 'color-danger';
          break;
        default:
          break;
      }
      return res;
    }
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  methods: {
    getApi() {
      return baseMessages;
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'baseMessages') {
        this.getItem(row.id).then(obj => {
          this.drawertemp = { ...this.drawertemp, ...obj };
          this.menukeyArray = [
            { name: '', menukey: 'basemessagesview' }
          ]; // 要显示的标签
          if (this.drawertemp.isRead !== 1) {
            this.$store.commit('SET_ROUTERSCOUNT', { msgCount: -1, modelCode: 'basemessage' });
          }
          this.drawer = true;
          this.getList();
        });
      }
    },
    getItem(id) {
      return new Promise((resolve, reject) => {
        baseMessages.get(id).then(result => {
          if (result.code === 200) {
            resolve(result.result);
          } else {
            reject(result.message);
          }
        }).catch(err => {
          reject(err);
        });
      });
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
